import React from 'react';
import { Route } from 'react-router-dom';
import SendEmailStudents from '@/pages/communication/SendEmailStudents';
import SendSMSStudents from '@/pages/communication/SendSMSStudents';
import SendWhatsapp from '@/pages/communication/SendWhatsapp';
import SendEmailSuppliers from '@/pages/communication/SendEmailSuppliers';
import SendEmailStaff from '@/pages/communication/SendEmailStaff';
import SendNotification from '@/pages/notifications/SendNotification';
import MessagingCenter from '@/pages/messaging/MessagingCenter';
import EmailLogs from '@/pages/communication/EmailLogs';

export const communicationRoutes = (
  <React.Fragment>
    <Route path="communication/notifications" element={<SendNotification />} />
    <Route path="communication/email-students" element={<SendEmailStudents />} />
    <Route path="communication/sms-students" element={<SendSMSStudents />} />
    <Route path="communication/whatsapp" element={<SendWhatsapp />} />
    <Route path="communication/email-suppliers" element={<SendEmailSuppliers />} />
    <Route path="communication/email-staff" element={<SendEmailStaff />} />
    <Route path="communication/messages" element={<MessagingCenter />} />
    <Route path="communication/email-logs" element={<EmailLogs />} />
  </React.Fragment>
);
